/** Keep in sync with apps/back/src/api/models/agentic/sharedSchemas.js TOOL_TRIGGERS */
export const TOOL_TRIGGERS = [
  'agent',
  'onStart',
  'onEnd',
  'onEnhancedFinished',
  'onUserTranscription',
  'onBeforeUserMessage',
  'onAgentTranscription',
  'onBeforeFirstMessage',
];

export const LEGACY_TOOL_TRIGGER_ALIASES = {
  onAgentMessage: 'onAgentTranscription',
};

export function normalizeToolTrigger(trigger) {
  const value = trigger || 'agent';
  return LEGACY_TOOL_TRIGGER_ALIASES[value] || value;
}

/** Triggers that run on lifecycle events, not via LLM tool calls. */
export const LIFECYCLE_TOOL_TRIGGERS = TOOL_TRIGGERS.filter(t => t !== 'agent');

/** Built-ins attachable at agent level (lifecycle-only; not LLM-callable). */
export const AGENT_GLOBAL_BUILTIN_NAMES = ['announce'];

export function isLifecycleDbTool(tool) {
  return normalizeToolTrigger(tool?.trigger) !== 'agent';
}
